import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EvsbFinalInvoiceComponent } from './pages/evsb-final-invoice/evsb-final-invoice.component';
import { EvsbProductOverviewComponent } from './pages/evsb-product-overview/evsb-product-overview.component';
import { EvsbThankYouMailComponent } from './pages/evsb-thank-you-mail/evsb-thank-you-mail.component';
import { EvsbThankYouOutboundCardsComponent } from './pages/evsb-thank-you-outbound/evsb-thank-you-outbound-cards.component';
import { EvsbThankYouOutboundStationsComponent } from './pages/evsb-thank-you-outbound/evsb-thank-you-outbound-stations.component';
import { EvsbThankYouComponent } from './pages/evsb-thank-you/evsb-thank-you.component';
import { EvsbVirtualCheckupComponent } from './pages/evsb-virtual-checkup/evsb-virtual-checkup.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'product-overview',
    pathMatch: 'full',
  },
  {
    path: 'product-overview',
    component: EvsbProductOverviewComponent,
  },
  {
    path: 'final-invoice',
    component: EvsbFinalInvoiceComponent,
  },
  {
    path: 'thank-you',
    component: EvsbThankYouComponent,
  },
  {
    path: 'thank-you-mail',
    component: EvsbThankYouMailComponent,
  },
  {
    path: 'thank-you-outbound-cards',
    component: EvsbThankYouOutboundCardsComponent,
  },
  {
    path: 'thank-you-outbound-stations',
    component: EvsbThankYouOutboundStationsComponent,
  },
  // development only paths:
  {
    path: 'dev',
    children: [
      {
        path: 'virtual-checkup',
        component: EvsbVirtualCheckupComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EvcSmallBizRoutingModule {}
